"use strict";

exports.supportedLanguages = ['de', 'en', 'es', 'fr', 'it', 'nl', 'sv'];
exports.DEFAULT_LANGUAGE = 'en';
exports.customUserAgentMap = {
  'Ecosia Android': /(\(Ecosia android@[a-z0-9.-]*\))/,
  'Ecosia iOS': /(\(Ecosia ios@[a-z0-9.-]*\))/
};
exports.cookieOptions = {
  DOMAIN: '.ecosia.org',
  EXPIRES: 365,
  NAME: 'ECFG',
  PATH: '/'
}; // The cookie is indexed using ":" to separate key/value
// pairs, and "=" to separate keys/values.
// For example, t=10:l=en:a=0 represents { t: 10, l: en, a: 0 }

exports.COOKIE_SEPARATOR = ':';
exports.COOKIE_VALUATOR = '=';
exports.cookieOptInKeys = ['ma'];
exports.cookieMap = {
  a: 'addOn',
  as: 'autoSuggest',
  cid: 'clientId',
  cs: 'customSettings',
  dt: 'deviceType',
  f: 'adultFilter',
  fr: 'firstRun',
  fs: 'firstSearch',
  l: 'language',
  lt: 'lastTree',
  ma: 'marketApplied',
  mc: 'bingMarketCode',
  nf: 'notifications',
  nt: 'newTab',
  ps: 'personalizedSearch',
  t: 'treeCount',
  tt: 'typeTag',
  tu: 'temperatureUnit',
  wu: 'windUnit'
};
exports.defaultCookie = {
  a: 0,
  as: 1,
  cs: 0,
  dt: 'pc',
  f: 'i',
  fr: 0,
  fs: 1,
  l: null,
  lt: 0,
  mc: 'en-us',
  nf: 1,
  nt: 0,
  ps: 1,
  t: 0,
  tt: 'na',
  // Needed to trigger bing reporting for non-typetagged users
  tu: 'auto',
  wu: 'auto'
};